import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import store from '@/store';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { getCreativeTemplateApi } from '@/api/creative';
import { getButtonTitleApi } from '@/api/tool/button-title';

/**
 * 管理OPPO渠道的数据
 */
export default class OppoDataSourceController extends DataSourceController {
  /**
   * 获取投放内容
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: `${name}（${id}）`, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取自动优化目标枚举
   * @returns {Promise<Object[]>}
   */
  async getOcpxOptimizeTypeEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_ocpx_optimize_type : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getConvertGoalListApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepConvertGoalApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取创意规格列表
   * @param {Object} params 查询参数
   * @returns {Promise<Object[]>}
   */
  getCreativeTemplateList(params = {}) {
    return new Promise((resolve, reject) => {
      const payload = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...params,
      };
      getCreativeTemplateApi(payload).then(res => {
        const result = (res?.list || []).map(({ id, name }) => ({ label: name, value: id }));
        resolve(result);
      }).catch(reject);
    });
  }

  /**
   * 获取按钮文案
   * @returns {Promise<Object[]>}
   */
  getButtonTitle() {
    return new Promise((resolve, reject) => {
      const payload = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
      };
      getButtonTitleApi(payload).then(res => {
        const result = (res?.list || []).map(({ id, name }) => ({ label: name, value: name }));
        resolve(result);
      }).catch(reject);
    });
  }

  /**
   * 获取未安装天数枚举
   * @returns {Promise<Object[]>}
   */
  async getAppUninstallDaysEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_app_uninstall_days : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取最近卸载时间枚举
   * @returns {Promise<Object[]>}
   */
  async getPromoteAppNotInstalledEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_promote_app_not_installed : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取过滤时间枚举
   * @returns {Promise<Object[]>}
   */
  async getFilterConvertedAdDaysEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_filter_converted_ad_days : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
